import React, { useState, useEffect } from "react";
import { questions } from "../assets/questions/questions";
//import useShuffle from "../hooks/useShuffle";

export const GameContext = React.createContext([{}, () => {}]);

export const GameProvider = ({ children }) => {
  const [view, setView] = useState("start");
  const [userAnswer, setUserAnswer] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selected, setSelected] = useState("");
  const [isFlipped, setIsFlipped] = useState(false);
  const [result, setResult] = useState(false);
  const [deskQuest, setDeskQuest] = useState(false);
  const [numCorrectAnswers, setNumCorrectAnswers] = useState(0);
  // const [questionsArray, setQuestionsArray] = React.useState(
  //   useShuffle([...questions])
  // );
  // const [currentQuestion, setCurrentQuestion] = React.useState(
  //   questionsArray[0].id
  // );
  const questionsArray = [...questions];

  const checkAlreadyAnswerd = (index) => {
    const res = userAnswer.find((obj) => {
      return obj.id === index;
    });

    if (res) {
      setSelected(res.selected);
    } else {
      setSelected("");
    }
  };

  useEffect(() => {
    let tempCorrectAnswers = userAnswer.filter((obj) => {
      return obj.correct;
    });
    setNumCorrectAnswers(tempCorrectAnswers.length);
  }, [userAnswer]);

  const restartGame = () => {
    setView("game");
    setIsFlipped(false);
    setSelected("");
    setUserAnswer([]);
    setCurrentQuestion(0);
    setDeskQuest(false);
    setNumCorrectAnswers(0);
  };

  const quitGame = (e) => {
    e.preventDefault();
    window.location.href = "http://mittval.nu";
  };

  return (
    <GameContext.Provider
      value={{
        userAnswer,
        setUserAnswer,
        currentQuestion,
        setCurrentQuestion,
        questionsArray,
        selected,
        setSelected,
        isFlipped,
        setIsFlipped,
        result,
        setResult,
        view,
        setView,
        checkAlreadyAnswerd,
        deskQuest,
        numCorrectAnswers,
        setDeskQuest,
        restartGame,
        quitGame,
      }}
    >
      {children}
    </GameContext.Provider>
  );
};
